module.exports = __webpack_public_path__ + "static/img/software5.44af50c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software5.jpg
// module id = 7XSb
// module chunks = 2